import React, { useState } from 'react'
import { Table } from '../../../components/ui/Table'
import { updateStatusString } from '../../../constants/update_status'
import { format } from 'date-fns'
import { updateReportAdTypeString } from '../../../config'
import { LoadFunc, useTableHooks } from '../../../packages/blueprint-components/src/useTableHooks'
import { useRecoilValue } from 'recoil'
import { unsuccessfulExports, unsuccessfulReports } from './update_details_state'
import Report = Models.Report
import { Column } from '../../../types/table'
import Export = Models.Export
import { number } from '../../../util/formatters'
import { Text } from '@blueprintjs/core'
import { FilterI } from '../../../constants/filter'

export const UnsuccessfulExports = () => {
    const [statusFilter, setStatusFilter] = useState<undefined | number>(null)
    const items = useRecoilValue(unsuccessfulExports)

    const load: LoadFunc<Export> = (params: any) => {
        if (params?.filter?.status_id) {
            setStatusFilter(parseInt(params.filter.status_id))
        } else {
            setStatusFilter(undefined)
        }

        return Promise.resolve({
            data: { data: [] },
        })
    }

    const tableHooks = useTableHooks(load)
    if (statusFilter) {
        tableHooks.items = items?.filter((item) => item.status_id === statusFilter) ?? []
    } else {
        tableHooks.items = items ?? []
    }

    const columns: Column<Export, any>[] = [
        {
            key: 'id',
            title: 'Export Id',
        },
        {
            key: 'export_id',
            formatter: (export_id: string | null) => {
                return (
                    <div style={{ maxWidth: '100px' }}>
                        <Text ellipsize>{export_id}</Text>
                    </div>
                )
            },
        },
        {
            key: 'status_id',
            title: 'Status',
            cell: (row: Export) => {
                return (
                    <span className="whitespace-nowrap">{updateStatusString(row.status_id)}</span>
                )
            },
        },
        {
            key: 'ad_type',
            cell: ({ ad_type }: Export) => updateReportAdTypeString(ad_type),
        },
        {
            key: 'filesize',
            formatter: (filesize: number | null) => (filesize ? number(filesize) : ''),
        },
        {
            key: 'params',
        },
        {
            key: 'url',
            formatter: (url: string | null) =>
                url ? (
                    <a href={url} target="_blank" rel="noreferrer">
                        Download
                    </a>
                ) : (
                    ''
                ),
        },
        {
            key: 'expires_at',
            cell: (row: Export) => {
                return (
                    <span className="whitespace-nowrap">
                        {row.created_at
                            ? format(new Date(row.expires_at as string), 'M/d/yy H:mm a')
                            : ''}
                    </span>
                )
            },
        },
        {
            key: 'created_at',
            cell: (row: Export) => {
                return (
                    <span className="whitespace-nowrap">
                        {format(new Date(row.created_at), 'M/d/yy H:mm a')}
                    </span>
                )
            },
        },
        {
            key: 'updated_at',
            cell: (row: Export) => {
                return (
                    <span className="whitespace-nowrap">
                        {format(new Date(row.updated_at), 'M/d/yy H:mm a')}
                    </span>
                )
            },
        },
    ]

    // console.log('items', tableHooks.items)

    const filters: [FilterI] = [
        {
            key: 'status_id',
            name: 'Status',
            type: 'select',
            options: [
                // @todo these are wrong
                { name: 'In Progress', value: 0 },
                { name: 'Request Finished', value: 1 },
                { name: 'Success', value: 2 },
                { name: 'Failure', value: 3 },
                { name: 'Created', value: 4 },
                { name: 'Downloaded', value: 5 },
                { name: 'Ingested', value: 6 },
            ],
        },
    ]

    return (
        <Table
            name="Exports"
            showHeader
            className="w-full"
            filters={filters}
            // filters={null}
            canSelect={false}
            columnSelection={false}
            columns={columns}
            tableHooks={tableHooks}
            onSelectChange={null}
            height={300}
        />
    )
}
